export default __webpack_public_path__ + "static/media/Abuja2.9ce0c069.jpg";